import { useState, useEffect, useRef } from "react";
import { collection, addDoc, query, orderBy, onSnapshot, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

function getChatId(uid1, uid2) {
  return [uid1, uid2].sort().join("_");
}

export function PrivateChatCard({ me, friend, onClose }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const chatId = getChatId(me.uid, friend.uid);
  const msgListRef = useRef(null);

  useEffect(() => {
    const q = query(
      collection(db, "privateChats", chatId, "messages"),
      orderBy("sentAt", "asc")
    );
    const unsub = onSnapshot(q, snap =>
      setMessages(snap.docs.map(doc => doc.data()))
    );
    return () => unsub();
  }, [chatId]);

  useEffect(() => {
    msgListRef.current?.scrollTo({ top: msgListRef.current.scrollHeight });
  }, [messages]);

  // 重點：用 form 包住，避免 Enter 觸發預設行為
  const onSubmit = async (e) => {
    e.preventDefault();
    const trimmed = input.trim();
    if (!trimmed) return;
    await addDoc(collection(db, "privateChats", chatId, "messages"), {
      from: me.uid,
      to: friend.uid,
      text: trimmed,
      sentAt: serverTimestamp()
    });
    setInput("");
  };

  return (
    <div className="private-chat-card">
      <div className="chat-header">
        <span>Chat with {friend.firstName || friend.uid.slice(-4)}</span>
        <button onClick={onClose} style={{ float: "right" }}>X</button>
      </div>
      <div className="chat-window" ref={msgListRef}>
        {messages.map((m, i) => (
          <div key={i} style={{
            textAlign: m.from === me.uid ? "right" : "left",
            color: m.from === me.uid ? "#2662a8" : "#222"
          }}>
            <span style={{ background: "#f2faff", borderRadius: 8, padding: 5, margin: 2 }}>
              {m.text}
            </span>
          </div>
        ))}
      </div>
      <form className="chat-input-area" onSubmit={onSubmit}>
        <input
          type="text"
          value={input}
          placeholder="Type a message…"
          onChange={e => setInput(e.target.value)}
        />
        <button type="submit">Send</button>
      </form>
    </div>
  );
}
